// extracted by mini-css-extract-plugin
export default {"imageContainer":"TalkMessageImage-module--imageContainer--0b764","image":"TalkMessageImage-module--image--0715b"};